import React from 'react';
import List from '@zapier/product-get-help/esm/components/shared/List';
import DocLink from './DocLink';
/** Renders a list of docs. */
const DocLinks = ({ links, size = 'large', trackingFields }) => (React.createElement(List, { gap: 5, itemRenderer: (item) => React.createElement(DocLink, Object.assign({}, item, { size: size, trackingFields: trackingFields })), items: links }));
export default DocLinks;
